/**
 * Bugünün tarihi, `YYYY-MM-DD` biçiminde ve **yerel** saate göre.
 *
 * `toISOString()` kullanılamaz: o her zaman UTC verir. Türkiye UTC+3 olduğu
 * için gece yarısı ile sabah 03:00 arasında UTC hâlâ bir önceki gündedir.
 * Sunucu ise tarihleri Europe/Istanbul'a göre süzüyor; ikisi ayrışınca o
 * saatlerde çalışan operatör kendi okuttuğu kayıtları "bu tarihte kayıt yok"
 * diye göremiyordu.
 */
export function bugunYerel(): string {
  const d = new Date();
  const ay = String(d.getMonth() + 1).padStart(2, '0');
  const gun = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${ay}-${gun}`;
}
